import { render, staticRenderFns } from "./FFButton.vue?vue&type=template&id=7a49120e&scoped=true&"
import script from "./FFButton.vue?vue&type=script&lang=js&"
export * from "./FFButton.vue?vue&type=script&lang=js&"
import style0 from "./FFButton.vue?vue&type=style&index=0&id=7a49120e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a49120e",
  null
  
)

export default component.exports